import { render, staticRenderFns } from "./EditorController.vue?vue&type=template&id=1179cdd3&scoped=true&"
import script from "./EditorController.vue?vue&type=script&lang=ts&"
export * from "./EditorController.vue?vue&type=script&lang=ts&"
import style0 from "./EditorController.vue?vue&type=style&index=0&id=1179cdd3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1179cdd3",
  null
  
)

export default component.exports